import { useEffect } from 'react';
import { emitMockRing } from '@/features/calls/popups/callsMock';
import { buildMockNotification, emitMockNotification } from '../notificationsMock';

const FIRST_MESSAGE_MS = 1500;
const MESSAGE_INTERVAL_MS = 9000;
const RING_AFTER_MS = 4000;
const MAX_DEMO_MESSAGES = 6;

/**
 * Opt-in demo traffic for reviewing the popups without a backend:
 * open the app with `?demo=1`. It emits through the same mock gateway the real
 * client will replace, so nothing about the pipeline is special-cased.
 */
export function useDemoStream(): void {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    if (!new URLSearchParams(window.location.search).has('demo')) return undefined;

    let sent = 0;
    const timeouts: number[] = [];

    const push = (): void => {
      if (sent >= MAX_DEMO_MESSAGES) return;
      emitMockNotification(buildMockNotification(sent));
      sent += 1;
    };

    timeouts.push(window.setTimeout(push, FIRST_MESSAGE_MS));
    timeouts.push(window.setTimeout(() => emitMockRing(), RING_AFTER_MS));
    const interval = window.setInterval(push, MESSAGE_INTERVAL_MS);

    return () => {
      for (const handle of timeouts) window.clearTimeout(handle);
      window.clearInterval(interval);
    };
  }, []);
}
